import config from "@/config/config";
import { FilterCriteria, ReclassifyTraumaObitoRequest, TraumaObitoResponse } from "@/domain/trauma.model";
import httpClient from "@/helpers/http-client";
import { formatQueryString } from "@/helpers/query-string";
import { IPaginate, IResponseWithPagination } from "@/interfaces/IPaginate";
import { headers } from "./headers";

export class TraumaObitoService {
  private static urlApiBase = config.url_api_reclassify;

  static list = (props: IPaginate<FilterCriteria>): Promise<IResponseWithPagination<TraumaObitoResponse[]>> => {
    const { offset, limit, order, sort, filter } = props;
    const query = formatQueryString({
      offset: offset || 1,
      limit: limit || 10,
      order,
      sort,
      filter: filter as unknown as Record<string, unknown>[],
      filterObject: true,
    });
    const url = `${this.urlApiBase}/trauma-obito${query}`;

    return httpClient
      .request<IResponseWithPagination<TraumaObitoResponse[]>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static getObitoById = (id: string): Promise<TraumaObitoResponse> => {
    return httpClient
      .request<TraumaObitoResponse>({
        url: `${this.urlApiBase}/trauma-obito/${id}`,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static reclassify = (id: string, data: ReclassifyTraumaObitoRequest): Promise<TraumaObitoResponse[] | undefined> => {
    return httpClient
      .request<TraumaObitoResponse[]>({
        url: `${this.urlApiBase}/trauma-obito/${id}/reclassify`,
        method: "POST",
        headers: headers(),
        body: data,
      })
      .then(result => result?.body);
  };

  static setReclassifiedSIM = (id: string): Promise<TraumaObitoResponse[] | undefined> => {
    return httpClient
      .request<TraumaObitoResponse[]>({
        url: `${this.urlApiBase}/trauma-obito/${id}/set-reclassified-sim`,
        method: "POST",
        headers: headers(),
        body: {},
      })
      .then(result => result?.body);
  };

  static setDeathTypeReviewed = (id: string, deathTypeReviewed: string): Promise<TraumaObitoResponse[] | undefined> => {
    return httpClient
      .request<TraumaObitoResponse[]>({
        url: `${this.urlApiBase}/trauma-obito/${id}/set-death-type-reviewed`,
        method: "POST",
        headers: headers(),
        body: {
          deathTypeReviewed,
        },
      })
      .then(result => result?.body);
  };

  static setWorkAccidentReviewed = (
    id: string,
    workAccidentReviewed: string,
  ): Promise<TraumaObitoResponse[] | undefined> => {
    return httpClient
      .request<TraumaObitoResponse[]>({
        url: `${this.urlApiBase}/trauma-obito/${id}/set-work-accident-reviewed`,
        method: "POST",
        headers: headers(),
        body: {
          workAccidentReviewed,
        },
      })
      .then(result => result?.body);
  };

  static exportCSV = (filter?: FilterCriteria, order?: string, sort?: string): Promise<Blob> => {
    const query = formatQueryString({
      filter: filter as unknown as Record<string, unknown>[],
      filterObject: true,
      order,
      sort,
    });
    const url = `${this.urlApiBase}/trauma-obito/export-csv${query}`;

    return httpClient
      .request<Blob>({
        url,
        method: "GET",
        responseType: "blob",
        headers: {
          ...headers(),
          Accept: "text/csv",
        },
      })
      .then(result => result?.body);
  };
}
